function _registerBoomSocialVideo() {
    if (customElements.get('boom-social-video')) return;
    customElements.define('boom-social-video',
    class BoomSocialVideo extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.isModalOpen = false;
        this._scrollLocked = false;
      }
      connectedCallback() {
        this.initData();
        this.bindElements();
        if (this.modal && this.modal.parentNode !== document.body) {
          document.body.appendChild(this.modal);
        }
        
        if (this.floating && this.floating.parentNode !== document.body) {
          document.body.appendChild(this.floating);
        }
        this.bindEvents();
      }

      disconnectedCallback() {
       
        if (this.modal && this.modal.parentNode === document.body) {
          document.body.removeChild(this.modal);
        }
        if (this.floating && this.floating.parentNode === document.body) {
          document.body.removeChild(this.floating);
        }
      }

      initData() {
        const dataScript = this.querySelector(`script[id^="BoomVideoData-"]`);
        try {
          this.videoSources = dataScript ? JSON.parse(dataScript.textContent) : [];
        } catch (e) {
          this.videoSources = [];
        }
      }

      bindElements() {
        this.slider = this.querySelector('[data-element="slider"]');
        this.modal = this.querySelector('[data-element="modal"]');
        this.modalVideo = this.querySelector('[data-element="modal-video"]');
        this.prevBtn = this.querySelector('[data-action="prev-video"]');
        this.nextBtn = this.querySelector('[data-action="next-video"]');
        this.scrollLeftBtn = this.querySelector('[data-action="scroll-left"]');
        this.scrollRightBtn = this.querySelector('[data-action="scroll-right"]');
        this.closeBtn = this.querySelector('[data-action="close-modal"]');
        this.floating = this.querySelector('[data-element="floating"]');
        this.floatingVideo = this.querySelector('[data-element="floating-video"]');
        this.closeFloatingBtn = this.querySelector('[data-action="close-floating"]');
        this.floatingToggleBtn = this.querySelector('[data-action="floating-toggle"]');
        this.floatingIcons = {
          play: this.querySelector('[data-icon="play"]'),
          pause: this.querySelector('[data-icon="pause"]'),
        };
        this.expandBtn = this.querySelector('[data-action="expand-floating"]');
        this.expand = this.querySelector('[data-element="floating-expand"]');
        this.expandVideo = this.querySelector('[data-element="floating-expand-video"]');
        this.closeExpandBtn = this.querySelector('[data-action="close-expand"]');
      }

      bindEvents() {
        if (this.slider) {
          this.slider.addEventListener('click', (e) => {
            const card = e.target.closest('.video-card');
            if (card) {
              const index = parseInt(card.dataset.index, 10);
              this.openModal(index);
            }
          });
        }
        if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.closeModal());
        if (this.closeFloatingBtn) this.closeFloatingBtn.addEventListener('click', () => this.closeFloating());
        if (this.floatingVideo) {
          this.initFloatingPlayer();
          this.floatingVideo.addEventListener('play', () => this.updateFloatingControl(true));
          this.floatingVideo.addEventListener('pause', () => {
            if (!this.isExpanded) this.updateFloatingControl(false);
          });
        }
        if (this.floatingToggleBtn) this.floatingToggleBtn.addEventListener('click', () => this.toggleFloating());
        if (this.expandBtn) this.expandBtn.addEventListener('click', () => this.openExpanded());
        if (this.closeExpandBtn) this.closeExpandBtn.addEventListener('click', () => this.closeExpanded());
        if (this.expand) {
          this.expand.addEventListener('click', (e) => {
            if (e.target === this.expand) this.closeExpanded();
          });
        }
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prevVideo());
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.nextVideo());
        if (this.modal) {
          this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.closeModal();
          });

          // 滚轮切换视频（带防抖锁，避免触控板一次滑动触发多次）
          this.modal.addEventListener('wheel', (e) => {
            if (!this.isModalOpen) return;
            e.preventDefault();
            this._handleScroll(e.deltaY);
          }, { passive: false });

          // 触屏滑动切换视频（移动端替代滚轮）
          let touchStartY = 0;
          this.modal.addEventListener('touchstart', (e) => {
            if (!this.isModalOpen) return;
            touchStartY = e.changedTouches[0].clientY;
          }, { passive: true });

          this.modal.addEventListener('touchend', (e) => {
            if (!this.isModalOpen) return;
            const deltaY = e.changedTouches[0].clientY - touchStartY;
            // 滑动距离超过 30px 才触发
            if (Math.abs(deltaY) > 30) {
              this._handleScroll(deltaY);
            }
          }, { passive: true });
        }
        if (this.scrollLeftBtn) this.scrollLeftBtn.addEventListener('click', () => this._scrollToCard(-1));
        if (this.scrollRightBtn) this.scrollRightBtn.addEventListener('click', () => this._scrollToCard(1));
        document.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          if (this.isExpanded) this.closeExpanded();
          else if (this.isModalOpen) this.closeModal();
        });
      }
      openModal(index) {
        if (!this.videoSources || !this.videoSources[index]) return;
        this.currentIndex = index;
        this.isModalOpen = true;
        this.modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        this.updatePlayer();
      }
      closeModal() {
        this.isModalOpen = false;
        if (this.modalVideo) this.modalVideo.pause();
        this.modal.style.display = 'none';
        document.body.style.overflow = '';
      }

      closeFloating() {
        if (this.floatingVideo) this.floatingVideo.pause();
        if (this.floating) this.floating.style.display = 'none';
      }

      initFloatingPlayer() {
        // 自动播放：只循环预览秒数；不自动播放：暂停等待用户点击播放完整视频
        const previewSeconds = parseFloat(this.floating && this.floating.dataset.previewSeconds);
        this.floatingAutoPlay = this.floating && this.floating.dataset.autoplay !== 'false';
        this.floatingStarted = false;
        this.floatingUnlocked = false;

        this.floatingVideo.addEventListener('timeupdate', () => {
          if (this.floatingUnlocked || !this.floatingAutoPlay) return;
          if (!previewSeconds || previewSeconds <= 0) return;
          if (this.floatingVideo.currentTime >= previewSeconds) {
            this.floatingVideo.currentTime = 0;
            this.floatingVideo.play().catch(() => {});
          }
        });

        if (this.floatingAutoPlay) {
          this.floatingVideo.play().catch(() => {});
          this.updateFloatingControl(true);
        } else {
          this.floatingVideo.pause();
          this.updateFloatingControl(false);
        }
      }

      toggleFloating() {
        if (!this.floatingVideo) return;
        // 非自动播放时，首次点击播放完整视频（不再受预览秒数限制）
        if (!this.floatingAutoPlay && !this.floatingStarted) {
          this.floatingStarted = true;
          this.floatingUnlocked = true;
          this.floatingVideo.currentTime = 0;
          this.floatingVideo.play().catch(() => {});
          return;
        }
        if (this.floatingVideo.paused) {
          this.floatingVideo.play().catch(() => {});
        } else {
          this.floatingVideo.pause();
        }
      }

      updateFloatingControl(playing) {
        if (!this.floatingIcons) return;
        if (this.floatingIcons.play) this.floatingIcons.play.style.display = playing ? 'none' : '';
        if (this.floatingIcons.pause) this.floatingIcons.pause.style.display = playing ? '' : 'none';
      }

      openExpanded() {
        if (!this.expand || !this.expandVideo) return;
        this.isExpanded = true;
        if (this.floatingVideo) this.floatingVideo.pause();
        const src = this.expandVideo.dataset.src;
        if (src && this.expandVideo.getAttribute('src') !== src) {
          this.expandVideo.src = src;
        }
        this.expand.style.display = 'flex';
        this.expandVideo.currentTime = 0;
        this.expandVideo.play().catch(() => {});
      }

      closeExpanded() {
        if (!this.isExpanded) return;
        this.isExpanded = false;
        if (this.expandVideo) this.expandVideo.pause();
        if (this.expand) this.expand.style.display = 'none';
        if (this.floatingVideo && this.floating) {
          // 放大播放完整视频后，缩回小窗也播放完整视频（不再受预览秒数限制）
          this.floatingUnlocked = true;
          this.floatingStarted = true;
          this.floatingVideo.currentTime = 0;
          this.floatingVideo.play().catch(() => {});
          this.updateFloatingControl(true);
        }
      }

      updatePlayer() {
        if (!this.modalVideo) return;
        this.modalVideo.src = this.videoSources[this.currentIndex];
        this.modalVideo.currentTime = 0;
        this.modalVideo.play().catch(() => {});
        if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.currentIndex === this.videoSources.length - 1;
      }
      _scrollToCard(direction) {
        if (!this.slider) return;
        const cards = this.slider.querySelectorAll('.video-card');
        if (!cards.length) return;

        const sliderRect = this.slider.getBoundingClientRect();
        const currentScroll = this.slider.scrollLeft;
        let nearestIndex = 0;
        let nearestDistance = Infinity;
        cards.forEach((card, i) => {
          const cardLeft = card.getBoundingClientRect().left - sliderRect.left + currentScroll;
          const cardCenter = cardLeft + card.offsetWidth / 2;
          const sliderCenter = currentScroll + this.slider.clientWidth / 2;
          const distance = Math.abs(cardCenter - sliderCenter);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = i;
          }
        });

        let targetIndex = nearestIndex + direction;
        // 边界钳制
        targetIndex = Math.max(0, Math.min(cards.length - 1, targetIndex));

        if (targetIndex !== nearestIndex) {
          const targetCard = cards[targetIndex];
          const targetLeft = targetCard.getBoundingClientRect().left - sliderRect.left + currentScroll;
          this.slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
        }
      }
      _handleScroll(deltaY) {
        if (this._scrollLocked) return;

        let switched = false;
        if (deltaY > 0 && this.currentIndex < this.videoSources.length - 1) {
          this.currentIndex++;
          this.updatePlayer();
          switched = true;
        } else if (deltaY < 0 && this.currentIndex > 0) {
          this.currentIndex--;
          this.updatePlayer();
          switched = true;
        }

        if (switched) {
          this._scrollLocked = true;
          setTimeout(() => { this._scrollLocked = false; }, 500);
        }
      }

      prevVideo() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updatePlayer();
        }
      }

      nextVideo() {
        if (this.currentIndex < this.videoSources.length - 1) {
          this.currentIndex++;
          this.updatePlayer();
        }
      }
    });
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(_registerBoomSocialVideo, { timeout: 500 });
  } else {
    setTimeout(_registerBoomSocialVideo, 500);
  }